<div class="flex h-full flex-col px-3 py-2">
  <div class="shrink-0 flex justify-between items-start gap-2 mb-2">
    <div>
      <h2 class="text-sm font-semibold text-slate-700">Ventas / facturación</h2>
      <p class="text-xs text-slate-400">Total facturado por día en el período</p>
    </div>
    <p class="text-base font-bold text-slate-900 whitespace-nowrap tabular-nums">
      {{ formatCurrency(periodTotal()) }}
    </p>
  </div>
  @if ((data()?.salesByDay?.length ?? 0) === 0) {
    <div class="flex-1 flex items-center justify-center text-slate-400 text-sm">
      Sin datos en el período
    </div>
  } @else {
    <div class="flex-1 min-h-0">
      <p-chart class="block h-full w-full" type="line" [data]="chartData()" [options]="chartOptions" />
    </div>
  }
</div>
